// Central source of truth for company facts. These values must match the
// records registered with Twilio for A2P 10DLC, so keep them exact.
export const COMPANY = {
  legalName: 'Cloutch LLC',
  domain: 'cloutch.com',
  email: 'ask@cloutch.com',
  supportEmail: 'support@cloutch.com',
  addressLine: '8735 Dunwoody Place Ste N',
  city: 'Atlanta',
  state: 'GA',
  zip: '30350',
  country: 'USA',
};

export const ADDRESS_FULL = `${COMPANY.addressLine}, ${COMPANY.city}, ${COMPANY.state} ${COMPANY.zip}, ${COMPANY.country}`;

export const PRODUCTS = [
  {
    name: 'Repatch',
    url: 'https://repatch.ai',
    blurb:
      'Repatch — an AI phone receptionist for home-service businesses that books appointments and sends customers confirmation and reschedule texts.',
    ownership: 'Repatch is a product of Cloutch LLC.',
  },
  {
    name: 'Edna',
    url: 'https://useedna.ai',
    blurb:
      'Edna — an AI phone host for restaurants that answers overflow calls, books reservations by voice, and texts diners confirmations and takeout/delivery links.',
    ownership: 'Edna is a product of Cloutch LLC.',
  },
];
